module.exports = __webpack_public_path__ + "img/om.44246af9.svg";